import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Lightning = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M10.9297 4.64358C10.9955 4.55279 11.0744 4.47117 11.1352 4.37699C11.4345 3.91378 11.1189 3.25 10.5306 3.25H7.60922C7.40356 3.25 7.20778 3.33978 7.07151 3.49658L4.9316 6.78504C4.52171 7.2567 4.85068 8 5.46931 8H5.60365C6.15899 8 6.48627 8.60284 6.23956 9.07145C6.19581 9.15456 6.14404 9.23403 6.10838 9.32092L5.1159 11.7392C5.04458 11.9129 4.91887 12.0737 4.90798 12.2612C4.8936 12.5086 5.08107 12.75 5.35986 12.75C5.44554 12.75 5.52946 12.7252 5.60182 12.6785L10.0104 9.13761C10.5227 8.80689 10.2926 8 9.68589 8C9.16913 8 8.90162 7.39299 9.20927 7.00175C9.24393 6.95768 9.28216 6.91617 9.31507 6.87078L10.9297 4.64358Z" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline" viewBox="0 0 16 16">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Lightning };